// extracted by mini-css-extract-plugin
export default {"containerThanks":"Thank_containerThanks__qKF2c","content":"Thank_content__YddoQ"};